import { Component, Injectable, OnInit } from '@angular/core';
import { AppSettingsService } from "../../../../shared/services/appsettings.service";
import { ContestService } from '../../../galleryModule/services/contest.service';

declare var selectAccount: any;
declare var signOut: any;
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})

@Injectable()
export class NavMenuComponent implements OnInit {

  contestOpenForVoting: boolean = false;
  lastCompletedContestYear: number;
  years: number[] = [];

  ngOnInit(): void {
    this.lastCompletedContestYear = AppSettingsService.settings.lastCompletedContestYear;
    selectAccount();

    // Generate years from 2020 to lastCompletedContestYear in descending order
    for (let year = this.lastCompletedContestYear; year >= 2020; year--) {
      this.years.push(year);
    }

    this._contestService.getContestOpenForVote()
      .subscribe(
        (response: number) => {
          this.contestOpenForVoting = response > 0;
        },
        error => { }
      );
  }

  constructor(private _contestService: ContestService) {

  }

  public logOut() {
    signOut(AppSettingsService.settings.b2CLogoutRedirectURI);
  }

  scrollTo(className: string): void {
    let elementList = document.querySelectorAll('.' + className);
    let element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}
